import { useState } from 'react';

export default function FinalCTA() {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      const formBody = new URLSearchParams();
      formBody.append('nombre', formData.nombre);
      formBody.append('email', formData.email);
      formBody.append('telefono', formData.telefono);

      const response = await fetch('https://readdy.ai/api/form/d4ld244u6ftm2u5dbbtg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitMessage('¡Gracias! Te contactaremos pronto con tu estimación gratuita.');
        setFormData({ nombre: '', email: '', telefono: '' });
      } else {
        setSubmitMessage('Hubo un error. Por favor, intenta de nuevo.');
      }
    } catch (error) {
      setSubmitMessage('Hubo un error. Por favor, intenta de nuevo.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="relative py-24 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/d2fa53faad7aa80d6d25d83fe40f490e.jpg')`
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-['Andrea'] text-4xl lg:text-5xl xl:text-6xl font-bold text-white mb-6">
            Tu vivienda puede ser tu mejor inversión.
          </h2>
          <p className="font-['Satoshi'] text-xl lg:text-2xl text-gray-100 max-w-3xl mx-auto">
            Haz clic y recibe una estimación gratuita hoy mismo.
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm rounded-lg p-8 shadow-2xl">
            <h3 className="font-['Andrea'] text-2xl font-bold text-[#2C3E50] mb-6 text-center">
              Solicita tu estimación gratuita
            </h3>
            
            <form onSubmit={handleSubmit} data-readdy-form className="space-y-4">
              <div>
                <label htmlFor="nombre-final" className="block font-['Satoshi'] text-sm font-medium text-gray-700 mb-2">
                  Nombre completo
                </label>
                <input
                  type="text"
                  id="nombre-final"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#2C3E50] focus:border-transparent outline-none transition-all font-['Satoshi'] text-sm"
                  placeholder="Tu nombre"
                />
              </div>

              <div>
                <label htmlFor="email-final" className="block font-['Satoshi'] text-sm font-medium text-gray-700 mb-2">
                  Correo electrónico
                </label>
                <input
                  type="email"
                  id="email-final"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#2C3E50] focus:border-transparent outline-none transition-all font-['Satoshi'] text-sm"
                  placeholder="tu@email.com"
                />
              </div>

              <div>
                <label htmlFor="telefono-final" className="block font-['Satoshi'] text-sm font-medium text-gray-700 mb-2">
                  Teléfono móvil
                </label>
                <input
                  type="tel"
                  id="telefono-final"
                  name="telefono"
                  value={formData.telefono}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#2C3E50] focus:border-transparent outline-none transition-all font-['Satoshi'] text-sm"
                  placeholder="+34 600 000 000"
                />
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-[#2C3E50] text-white font-['Satoshi'] font-semibold py-4 px-6 rounded-md hover:bg-[#34495E] transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
              >
                {isSubmitting ? 'Enviando...' : 'Recibe tu estimación gratuita'}
              </button>

              {submitMessage && (
                <div className={`mt-4 p-4 rounded-md ${submitMessage.includes('Gracias') ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>
                  <p className="font-['Satoshi'] text-sm">{submitMessage}</p>
                </div>
              )}
            </form>

            <div className="mt-6 text-center">
              <p className="font-['Satoshi'] text-sm text-gray-600 mb-4">O contáctanos directamente</p>
              <a 
                href="https://wa.me/34633123150"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#25D366] text-white font-['Satoshi'] font-semibold py-3 px-6 rounded-md hover:bg-[#20BA5A] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                Chatea con nosotros
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
